module.exports = __webpack_public_path__ + "static/media/Bell_beaker_lba_scotland.9998edb4.png";